var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEa(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.98 102.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.74,74.6,55.31,59.17l1.77-1.77a20.69,20.69,0,1,0-29.17,0l1.76,1.77L14.25,74.6l-1.77-1.77a42.7,42.7,0,0,1,0-60.33A42.49,42.49,0,0,1,85,42.66,42.35,42.35,0,0,1,72.5,72.83ZM42.48,5A37.68,37.68,0,0,0,14.3,67.47l8.39-8.38a25.73,25.73,0,1,1,39.61,0l8.38,8.38A37.66,37.66,0,0,0,42.48,5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "42.49 102.63 19.63 79.77 23.16 76.23 42.49 95.56 61.43 76.63 64.96 80.16 42.49 102.63"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEa);
export default __webpack_public_path__ + "static/media/ea.82526678e4ed5d57e2e60e7037638231.svg";
export { ForwardRef as ReactComponent };